<div class="adminui-dialog__backdrop"></div>

<div class="adminui-dialog__container">
  <div class="adminui-dialog" [ngClass]="['adminui-dialog--' + type, 'adminui-dialog--' + size]"
       [attr.role]="dialogRole" aria-modal="true" [attr.aria-labelledby]="titleId"
       [attr.aria-describedby]="bodyId" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">

    <div class="adminui-dialog__top-section">
      @if (iconClass) {
        <span class="adminui-dialog__icon"><i [class]="iconClass" aria-hidden="true"></i></span>
      }

      <div class="adminui-dialog__heading">
        <div class="adminui-dialog__label">
          <h4 class="adminui-dialog__title" [id]="titleId">{{ title }}</h4>
        </div>
        <div class="adminui-dialog__content" [id]="bodyId">
          <ng-content></ng-content>
        </div>
      </div>

      @if (dismissable) {
        <button type="button" class="adminui-dialog__close-icon" [attr.aria-label]="closeLabel"
                (click)="onCloseClick()">
          <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      }
    </div>

    <div class="adminui-dialog__actions">
      <ng-content select="[dialogFooter]"></ng-content>
    </div>
  </div>
</div>
